module.exports = __webpack_public_path__ + "img/warning.39d25412.svg";